/* =========================================================================
   Sarvarth — Festive Gifting landing page
   Reports catalogue-download and WhatsApp-enquiry clicks as separate events.

   Destinations (each guarded, so a missing integration is harmless):
     • Shopify Web Pixels  — Shopify.analytics.publish('sarvarth_festive_cta_click')
     • Google Tag Manager  — dataLayer push
     • Meta Pixel          — fbq('trackCustom', ...) when the pixel is present
   ========================================================================= */
(function () {
  'use strict';

  var EVENT_NAME = 'sarvarth_festive_cta_click';

  function report(action, location) {
    var payload = {
      cta: action,
      location: location,
      page: 'festive-gifting'
    };

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(EVENT_NAME, payload);
      }
    } catch (e) {}

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'festive_cta_click',
        festive_cta: action,
        festive_location: location
      });
    } catch (e) {}

    try {
      if (typeof window.fbq === 'function') {
        window.fbq(
          'trackCustom',
          action === 'catalogue' ? 'FestiveCatalogueDownload' : 'FestiveWhatsAppEnquiry',
          { location: location }
        );
      }
    } catch (e) {}
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest('[data-sf-cta]');
      if (!trigger) return;

      var action = trigger.getAttribute('data-sf-cta');
      if (action !== 'catalogue' && action !== 'whatsapp') return;

      report(action, trigger.getAttribute('data-sf-location') || 'unknown');
    },
    false
  );
})();
